<template>
  <div>
    <Button class="float-right" @click="handleCreateClick">
      {{ $t('userManager.actions.createRole') }}
    </Button>
    <h1> {{ $t('userManager.actions.manageRoles') }} </h1>
    <UmisisDataTableIntegrated :fields="fields" :use-store="userRoleStore">
      <template #cell(name)="{ row }">
        <div>{{ row.name }}</div>
        <div>
          <div class="flex flex-wrap gap-1 mt-1">
            <Badge v-for="permission in row.permissions" :key="`user-permission-${permission.id}`">
              {{ permission.name }}
            </Badge>
          </div>
        </div>
      </template>
      <template #cell(actions)="{ row }">
        <div class="flex flex-col gap-2 sm:flex-row">
          <Button variant="default" @click="handleEditClick(row)">
            {{ $t('userManager.actions.editRole') }}
          </Button>
          <UmisisDeleteItemButton :delete-by-value="row.id" :use-store="userRoleStore" @deleted="deletedRole" />
        </div>
      </template>
    </UmisisDataTableIntegrated>
    <UserRoleEditModal v-if="selectedRole" ref="userRoleEditModalRef" :user-role="selectedRole" @closed="selectedRole = null" />
    <UserRoleEditModal ref="userRoleCreateModalRef" />
  </div>
</template>

<script setup>
// This component is intentionally simple.
// You can add any shared logic for your package's routes here.
import UmisisDeleteItemButton from '../../../../../../resources/js/components/umisis/generic/UmisisDeleteItemButton.vue'
import UmisisDataTableIntegrated from '../../../../../../resources/js/components/umisis/generic/UmisisDataTableIntegrated.vue'
import { Button } from '../../../../../../resources/js/components/ui/button/index.js'
import { useI18n } from 'vue-i18n'
import { useUserRoleStore } from '../stores/userRoleStore.js'
import { toast } from 'vue-sonner'
import { Badge } from '../../../../../../resources/js/components/ui/badge/index.js'
import UserRoleEditModal from '../components/user-roles/UserRoleEditModal.vue'
import { getCurrentInstance, nextTick, onBeforeUpdate, onMounted, ref } from 'vue'
const { t } = useI18n()

const userRoleEditModalRef = ref(null);
const userRoleCreateModalRef = ref(null);
// 2. One ref to hold the data of the row being edited
const selectedRole = ref(null)
const handleEditClick = async (row) => {
  // Set the data
  selectedRole.value = row;
  // Open the modal
  // (We use nextTick to ensure the prop 'selectedRole' is passed before opening)
  await nextTick();
  userRoleEditModalRef.value?.openModal();
}
let userRoleStore = useUserRoleStore()



const fields = [
  { name: 'id', label: 'ID', sortable: true },
  { name: 'name', label: 'Name', sortable: true },
  { name: 'email', label: 'Email', sortable: true },
  { name: 'created_at', label: 'Created At', sortable: true, formatter: (value) => new Date(value).toLocaleDateString() },
  { name: 'actions', label: 'Actions' },
]

const deletedRole = (data) => {
  console.log('User Role Deleted:', data)
  // Optionally refresh the user list or show a notification
  userRoleStore.fetchItems()
  // send the notification
  toast(t('userManager.notifications.roleDeleted'), {
    type: 'success',
  })
}


const handleCreateClick = () => {
  selectedRole.value = null; // Clear any previous selection
  nextTick(() => {
    userRoleCreateModalRef.value?.openModal();
  });
}



</script>
